import { Phone } from '@phosphor-icons/react';
import { BRAND } from '../lib/brand';

// Mobile-only sticky 24/7 click-to-call button
export const StickyCallButton = () => {
  return (
    <a
      href={`tel:${BRAND.phoneRaw}`}
      data-testid="sticky-call-btn"
      aria-label="Call India's Inking Service 24/7"
      className="md:hidden fixed bottom-20 right-4 z-40 flex items-center gap-2 bg-[#800000] text-white px-5 py-4 rounded-full shadow-2xl shadow-[#800000]/40 active:scale-95 transition-transform animate-gold-pulse"
    >
      <Phone weight="fill" size={22} className="text-[#D4AF37]" />
      <span className="font-semibold text-sm">Call 24/7</span>
    </a>
  );
};
